import { AppConfig, Faq, Topic } from '../Models';

export const getTopic = (config: AppConfig, id: number): Topic | undefined =>
  config.body.topics.find((topic: Topic) => topic.id === id);

export const getTopicsByIds = (
  config: AppConfig,
  topicIds: number[]
): Topic[] => {
  let topics: Topic[] = [];

  for (let topicId of topicIds) {
    const topic = getTopic(config, topicId);
    if (topic) {
      topics = [...topics, topic];
    }
  }

  return topics;
};

export const getFaq = (config: AppConfig, id: number): Faq | undefined =>
  config.body.faqs.find((faq: Faq) => faq.id === id);

export const getFaqsByIds = (config: AppConfig, faqIds: number[]): Faq[] => {
  let faqs: Faq[] = [];

  for (let faqId of faqIds) {
    const faq = getFaq(config, faqId);
    if (faq && faq.active) {
      faqs = [...faqs, faq];
    }
  }

  return faqs;
};
